import { Alert, Box, Divider } from '@mui/material'
import { useState } from 'react'
import { OrderRequestForm } from './OrderRequestForm'

export function UnauthedOrderRequestPage() {
  const [lastSubmittedId, setLastSubmittedId] = useState<string | null>(null)

  function handleSuccess(requestId: string) {
    setLastSubmittedId(requestId)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Box sx={{ p: 2, maxWidth: 900, mx: 'auto', mt: '30px' }}>
      {lastSubmittedId ? (
        <Alert severity="success" sx={{ mb: 3, mt: 5,  display: 'flex', justifyContent: 'center' }}>
          Your title order request has been submitted successfully. A team member will follow up with you shortly.
        </Alert>
      ) : (
        <>
          <Divider sx={{ mb: 2 }} />
          <OrderRequestForm onSuccess={handleSuccess} unauthed />
        </>
      )}
    </Box>
  )
}
